import type React from 'react';

import { GradientLoadingSpinner } from '@blank-slate-tech/uikit-web';

export const LoadingFallback: React.FC = () => {
  return (
    <div className="absolute bottom-0 left-0 right-0 top-0 flex h-full min-h-full w-full min-w-full items-center justify-center">
      <GradientLoadingSpinner sizeType="XL" />
    </div>
  );
};
